import React from "react";
import SpotifySlider from "../HeaderComponent/SliderComponent/SpotifySlider";

const Home = () => {
  return (
    <div>
      <SpotifySlider />
    </div>
  );
};

export default Home;
